import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';
import useInboxSummary from '../hooks/useInboxSummary';

/**
 * Provides live inbox unread counts to any admin-visible component (the
 * AdminBar badge and the AdminDashboard tab labels), and a `refresh()` fn
 * so views can force a re-poll immediately after they mark items read.
 */
const InboxContext = createContext({ summary: { prayers: 0, contacts: 0, hall_rentals: 0, registrations: 0, total: 0 }, refresh: () => {} });

export const InboxProvider = ({ children }) => {
  const { isAdmin } = useAuth();
  const { summary, refresh } = useInboxSummary(isAdmin);
  return (
    <InboxContext.Provider value={{ summary, refresh }}>
      {children}
    </InboxContext.Provider>
  );
};

export const useInbox = () => useContext(InboxContext);
